export default "__VITE_ASSET__D$l7WjZi__"